import lodash from 'lodash';
import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const { memoize } = lodash;
const getMemoizedWalletAccountSelectorFactory = (walletAccountsSelector) => memoize((name) => createSelector((state) => walletAccountsSelector(state)[name], (walletAccount) => walletAccount));
export default defineSelectorFactory({
    id: 'getMemoized',
    selectorFactory: getMemoizedWalletAccountSelectorFactory,
    dependencies: [
        { selector: 'data' },
    ],
});
